import { Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, User } from '@heroui/react'
import { ChevronDown } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'

import LeangapLogo from '@/components/public/LeangapLogo'
import { authCache } from '@/services/auth-cache'
// import { formProgress } from '@/utils/form-progress'
import { post } from '@/services/api'
import { useAppStore } from '@/store'
import { appStore } from '@/store/app'
import { setSentryUser } from '@/lib/sentry'

export default function Topbar() {
	const nav = useNavigate()
	const { user } = useAppStore()

	const onLogout = async () => {
		try {
			await post('/auth/logout', {})
		} finally {
			authCache.clear() // clear localStorage + memory
			appStore.reset() // clear in-memory user
			setSentryUser(null) // clear Sentry user context
			// formProgress.reset() // clear local step flags, if used
			nav('/', { replace: true })
		}
	}

	const hasName = user?.name?.trim() && user?.name?.trim() !== ''
	const displayName =
		hasName && user?.name
			? `Hi, ${user.name.trim().length > 10 ? user.name.trim().slice(0, 10) + '...' : user.name.trim()}`
			: 'Your account'
	// const avatarName = hasName ? user?.name?.trim() : undefined;

	return (
		<header className="bg-background sticky top-0 z-10 shadow-sm">
			<nav>
				<div className="container mx-auto flex justify-between p-4">
					<Link className="inline-block" to="/" title="Leangap">
						<LeangapLogo width={112} />
					</Link>

					<Dropdown backdrop="blur">
						<DropdownTrigger>
							<button
								type="button"
								className="flex cursor-pointer items-center gap-1 transition-transform focus:outline-none"
							>
								<User className="pointer-events-none" name={displayName} />
								<ChevronDown className="text-default-500 h-4 w-4 shrink-0" />
							</button>
						</DropdownTrigger>
						<DropdownMenu aria-label="Static Actions" variant="faded">
							<DropdownItem key="home" onClick={() => nav('/account/steps')}>
								Home
							</DropdownItem>
							<DropdownItem key="logout" onClick={onLogout}>
								Logout
							</DropdownItem>
						</DropdownMenu>
					</Dropdown>
				</div>
			</nav>
		</header>
	)
}
